<div class="container-fluid">
  <div class="row title-bar" [ngClass]="{ 'title-bar-warning': type === 'warning' }">
    <div class="page-title">
      <h1>{{title}}</h1>
    </div>
    <div class="action-bar"></div>
  </div>
</div>